module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"columns":{"pc_name":"PC Name","version":"EDM Version","updateDate":"Updated On"}},"zh-CHS":{"columns":{"pc_name":"电脑名称","version":"EDM版本","updateDate":"最后更新时间"}}}')
  delete Component.options._Ctor
}
